import React, {Component, Fragment} from 'react'
import '../../../../assets/sass/pages/watchlist.scss';
import MainToolbar from "./MainToolbar";
import WatchlistDataTable from "./WatchlistDataTable";
import rows, {remoteData} from '../PlayerRows';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {removeWatchlist} from "../../../../store/actions/WatchlistActions";
import NoData from "../../../ui/NoData";

class Watchlist extends Component {
    /**
     * Renders the talent search screen.
     * @returns {React.ReactNode} The talent search screen.
     */
    render = () => {
        const {isEmpty} = this.props;
        return isEmpty ? this.NoData() : this.loadPage();
    };

    loadPage = () => {
        return (
            <div className="watchlist-wrapper">
                {this.renderToolbar()}
                {this.renderTable()}
            </div>
        );
    };

    NoData = () => {
        return (
            <Fragment>
                <NoData
                    title="You have not added any player in watchlist yet"
                    description="You can add players in watchlist from Talent Search. Watchlist allows you to keep an eye and track performances of players you want"
                />
            </Fragment>
        );
    };

    /**
     * Renders the toolbar of talent search table.
     * @returns {React.ReactNode} The talent of search datatable toolbar.
     */
    renderToolbar = () => {

        const {selectedPlayers} = this.props;
        const selectedPlayersCount = selectedPlayers.length;

        return (
            <MainToolbar
                selectedCount={selectedPlayersCount}
                onSearchChange={this.handleSearchChange}
                oneDeletePlayers={this.handleDeleteButton}
            />
        );
    };

    /**
     * Renders the talent of search datatable.
     * @returns {React.ReactNode} The talent of search datatable.
     */
    renderTable = () => {
        return (
            <WatchlistDataTable/>
        );
    };

    handleBookmarkClick = (event, row) => {
        // row.props.bookmarked = !row.props.bookmarked;
        // this.forceUpdate();
    };

    handleRowSelect = (event, rows) => {
        this.setState({
            rows: rows
        });
    };

    handleSearchChange = (event) => {
        const value = event.target.value;
        this.setState({
            ...this.state,
            filters: {
                ...this.filter,
                searchValue: value,
            }
        }, this.UpdateTable);
    };

    handleDeleteButton = (event) => {
        this.state.rows.map((row, index) => {
            if (row.selected) {
                this.props.removeWatchlist(row.id);
            }
        });

        this.setState({
            rows: this.state.rows.filter((row, index) => {
                if (!row.selected)
                    return row;
            })
        })
    }
}

const mapStateToProps = (state) => {
    return {
        isEmpty: state.watchlist.isEmpty,
        selectedPlayers: state.watchlist.datatable.selectedPlayers,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        removeWatchlist: (key) => dispatch(removeWatchlist(key))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Watchlist));

